import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "add", "preview", "previewImage", "status"]

  connect() {
    if (
      this.hasPreviewImageTarget &&
      this.previewImageTarget.getAttribute("src")
    ) {
      this.showPreview()
    }
  }

  disconnect() {
    this.revokeObjectUrl()
  }

  preview() {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    this.revokeObjectUrl()
    this.objectUrl = URL.createObjectURL(file)
    this.previewImageTarget.src = this.objectUrl
    this.previewImageTarget.alt = file.name

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = file.name
    }

    this.showPreview()
  }

  replace() {
    this.inputTarget.click()
  }

  showPreview() {
    this.previewTarget.hidden = false
    this.addTarget.hidden = true
  }

  hidePreview() {
    this.previewTarget.hidden = true
    this.addTarget.hidden = false
  }

  revokeObjectUrl() {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
